import React, {Component} from 'react';

import Layout from '../../components/Layout'
import MyProfile from '../../pages/MyProfile'
import Loading from "../MyDorm";

class MyProfileContainer extends Component {
	render() {
		const {profile} = this.props;

		return (
			<Layout {...this.props} noSideBar>
				{profile === null || profile === undefined ? <Loading/> :

					<MyProfile {...this.props}/>}
			</Layout>
		);
	}
}


export default MyProfileContainer;
